import React, { Component } from "react";
import {
    IconButton,
    Grid,
    List,
    ListItem,
    MenuItem,
    TextField,
    Button,
    Select,
    Typography,
    Divider
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import moment from "moment";
import { formatDate, parseDate } from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { noImg } from "vrcore-dashboard/dist/utilities";
import styled from "styled-components";
import { Modal, ModalBody, ModalFooter, Row, Col, Label, Input } from "reactstrap";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { getBroadcast, addBroadcast, uploadFile, uploadFileManager, removeBroadcast, updateExistingBroadcast } from "./actions";
import WarningIcon from "@material-ui/icons/Warning";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import {
    StyledContent,
    StyledHeader,
} from "../../../styles";
import AddIcon from "@material-ui/icons/PlaylistAdd";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from '@material-ui/icons/Clear';
import {
    MaxFileSizeSnackbar,
} from "./components";
const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;

const currentDate = moment().format("DD-MM-YYYY");

const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
let pointFlag = false
let refBroadcast
let arr = [];
class NewsBroadcastV2 extends Component {
    constructor(props) {
        super(props);
        props.getBroadcast();
        this.state = {
            uploadImageLocal: false,
            uploadImageLocalMultiple: [],
            newBroadcast: {
                warning_level_status: "Green",
                message: "",
                attached_photos: [],
                start_date: currentDate,
                end_date: currentDate,
                days: [],
                points: [],
                created_by: {
                    user_uid: "",
                    user_name: ""
                }
            },
            viewBroadcastModal: false,
            setBroadcastModal: false,
            BroadcastListModal: false,
            removeBroadcastModal: false,
            editBroadcastModal: false,
            removeUID: false,
            confirmButton: false,
            imageModal: false,
            selectedImg: false,
        };
    }

    handleViewGroupModal = () => {
        this.setState({ viewBroadcastModal: true });
        this.setState({ uploadImageLocal: false });
    };
    handleCloseViewGroupModal = () => {
        this.setState({ viewBroadcastModal: false });
        this.setState({ uploadImageLocal: false });
    };
    handleViewGroupModal = () => {
        this.setState({ viewBroadcastModal: true });
        this.setState({ uploadImageLocal: false });
    };
    handleRemoveGroupModal = () => {
        this.setState({ removeBroadcastModal: true });
    };
    handleCloseRemoveGroupModal = () => {
        this.setState({ removeBroadcastModal: false });
    };
    handleNewGroupModal = () => {
        this.setState({
            uploadImageLocal: false,
            uploadImageLocalMultiple: [],
            newBroadcast: {
                warning_level_status: "Green",
                message: "",
                attached_photos: [],
                start_date: currentDate,
                end_date: currentDate,
                days: [],
                points: [],
                created_by: {
                    user_uid: "",
                    user_name: ""
                }
            },
            viewBroadcastModal: false,
            setBroadcastModal: true,
            BroadcastListModal: false,
            removeBroadcastModal: false,
            removeUID: false,
            editBroadcastModal: false,
            confirmButton: false,
            imageModal: false,
            selectedImg: false,
        });
    };

    handleEditBroadcastModal = () => {
        this.setState({ editBroadcastModal: true });
    };
    handleEditBroadcastCloseModal = () => {
        this.setState({ editBroadcastModal: false });
        this.setState({ uploadImageLocal: false });
    };
    handleResetBroadcast = (status = []) => {
        refBroadcast = this.state.newBroadcast
        refBroadcast.points = status
        this.setState({ newBroadcast: refBroadcast })
    };
    handleResetBroadcastCreatedBy = () => {
        let refObj =  {
            user_uid: "",
            user_name: ""
        }
        refBroadcast = this.state.newBroadcast
        refBroadcast.created_by = refObj
        this.setState({ newBroadcast: refBroadcast })
    };
    
    // handleResetPhotos = ( status = []) =>{
    //         refBroadcast = this.state.newBroadcast
    //         refBroadcast.attached_photos = status
    //         this.setState({ newBroadcast: refBroadcast })
    // };
    setBackground(status) {
        if (status === "Green") {
            return "green";
        } else if (status === "Red") {
            return "red";
        } else if (status === "Yellow") {
            return "#B6B65D";
        } else {
            return "white";
        }
    }
    setFontcolor(status) {
        if (status === "Green") {
            return "black";
        } else if (status === "Red") {
            return "black";
        } else {
            return "black";
        }
    }

    renderRequiredGroupDetails = () => {
        return (
            <div>
                <ModalBody>
                    <div
                        style={{
                            marginLeft: 0,
                            position: "absolute",
                            bottom: 0,
                        }}
                    >
                        <br />
                        <Label
                            style={{ color: "#0288CC", marginLeft: "-15px" }}
                        >
                            {" "}
                            <b> Add Photos If Applicable </b>{" "}
                        </Label>
                    </div>
                </ModalBody>
                <ModalBody>
                    <input
                        type="file"
                        id="file"
                        accept="image/*"
                        ref="imageUploader"
                        multiple
                        style={{ display: "none" }}
                        onChange={(event) => {
                            if (
                                event.target.files[0] &&
                                event.target.files[0].size > 1000000
                            ) {
                                this.setState({
                                    fileMaxSizeSnackbar: true,
                                });
                            } else {
                                let local =
                                    this.state.uploadImageLocalMultiple || [];

                                let curr = [];
                                let data = this.state.newBroadcast;
                                if (event.target.files)
                                    Object.keys(event.target.files).map((f) => {
                                        curr.push(
                                            URL.createObjectURL(
                                                event.target.files[f]
                                            )
                                        );
                                        this.props.uploadFile(
                                            this.state.newBroadcast.message,
                                            event.target.files[f],
                                            (status) => {
                                                if (status.url) {
                                                    data.attached_photos.push(
                                                        status.url
                                                    );
                                                }
                                            }
                                        );
                                        return null;
                                    });
                                if (
                                    this.state.uploadImageLocalMultiple
                                        .length <= 3 &&
                                    event.target.files.length <= 4
                                )
                                    this.setState({
                                        newBroadcast: data,
                                        uploadImageLocalMultiple: [
                                            ...local,
                                            ...curr,
                                        ],
                                    });
                            }
                        }}
                    />
                    <div>
                        <ModalRow
                            style={{
                                padding: "5px",
                                border: "1px solid #4CAF50",
                                borderRadius: 5,
                            }}
                        >
                            <Col
                                style={{
                                    padding: "8px",
                                    border: "1px solid #4CAF50",
                                    borderRadius: 5,
                                }}
                            >
                                <center>
                                    <IconButton
                                        onClick={() => {
                                            this.refs.imageUploader.click();
                                        }}
                                        style={{
                                            margin: "inherit",
                                            color: "green",
                                            border: "1px solid green",
                                            marginTop: "40px",
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </center>
                                <Typography
                                    style={{ margin: "inherit" }}
                                    variant="body2"
                                >
                                    <center> {"( Max : 4 ) "} </center>
                                    <center> {"( < 1MB )"} </center>
                                </Typography>
                            </Col>
                            {this.state.uploadImageLocalMultiple &&
                                this.state.uploadImageLocalMultiple.map((e) => {
                                    return (
                                        <Col
                                            style={{
                                                padding: "3px",
                                                border: "1px solid #4CAF50",
                                                borderRadius: 5,
                                                marginLeft: "2px",
                                            }}
                                        >
                                            <img
                                                style={{
                                                    width: "150px",
                                                    height: "150px",
                                                }}
                                                src={e ? e : noImg}
                                                alt="Proof"
                                            />
                                        </Col>
                                    );
                                })}
                        </ModalRow>
                    </div>
                </ModalBody>
            </div>
        );
    };
    render() {
        const { sm, md, lg, activeBroadcast, userProfile, allBroadcastList } = this.props;
        const { selectedImg } = this.state;
        let name = userProfile.name
        let uid = userProfile.uid
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <div
                    style={{
                        position: "relative",
                        border: activeBroadcast.warning_level_status === "Green" ? "5px solid green" :
                            activeBroadcast.warning_level_status === "Red" ? "5px solid red" :
                                activeBroadcast.warning_level_status === "Yellow" ? "5px solid #d4d44e" :
                                    "5px solid white",
                        background: "white",
                        minWidth: "100%",
                        minHeight: "60px",
                        height: "100%",
                        padding: 0,
                        margin: 0,
                    }}
                >
                    <div style={{

                        color: this.setFontcolor(
                            activeBroadcast.warning_level_status
                        ),
                    }}>
                        <div style={{
                            width: "100%",
                            padding: 6,
                            paddingRight: 0,
                            paddingLeft: 2,
                        }}>
                            <span style={{ float: "left", fontSize: "17px" }}>
                                <b>Latests News Broadcasts:</b>
                            </span>
                            <span style={{ float: "right" }}>
                                {this.props.canCreate && (
                                    <Button
                                        style={{
                                            background: "#0188cc",
                                            display: "inline",
                                            marginTop: "-2px",
                                            marginRight: "18px",
                                            // height: "28px"
                                        }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.handleNewGroupModal();
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                color: "white",
                                                fontSize: "12px",
                                            }}
                                        >
                                            Create New Broadcast
                                        </Typography>
                                    </Button>
                                )}
                                <Button
                                    style={{
                                        background: "grey",
                                        display: "inline",
                                        marginTop: "-2px",
                                        marginRight: "18px",
                                        // height: "28px"
                                    }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.setState({
                                            BroadcastListModal: true,
                                        });
                                    }}
                                >
                                    <Typography
                                        style={{
                                            color: "white",
                                            fontSize: "12px",
                                        }}
                                    >
                                        All Broadcast List
                                        </Typography>
                                </Button>
                            </span>
                        </div>
                        <br />
                        <Divider
                            style={{
                                marginTop: "3px",
                                height: "3px",
                                background: "black",
                                marginLeft: "3px",
                                marginRight: "3px"
                            }}
                        />
                        <div>
                            <WarningIcon
                                style={{
                                    color: this.setBackground(
                                        activeBroadcast.warning_level_status
                                    ),
                                    float: "left",
                                    display: "block",
                                    margin: "6px 16px 16px 6px",
                                    height: "34px",
                                    width: "34px"
                                }}
                            />
                            <p style={{ marginLeft: "4px", marginBottom: "0px", paddingTop: "2px", fontWeight: "bold", color: this.setFontcolor(activeBroadcast.warning_level_status) }}>
                                <span>{`${activeBroadcast.message
                                    ? activeBroadcast.message
                                    : "N/A"
                                    }  - `}
                                </span>{" "}

                                <span>{`${activeBroadcast.points
                                    ? activeBroadcast.points.length
                                    : "0"
                                    } Points - `}
                                </span>{" "}
                                <span style={{ fontWeight: 300 }}>{`Submitted By: ${activeBroadcast.created_by
                                    ? activeBroadcast.created_by.user_name
                                    : "N/A"
                                    } - `}
                                </span>{" "}
                                <span style={{ fontWeight: 300 }}>
                                    {activeBroadcast.timestamp + " "}
                                </span>
                                <span>
                                </span>
                                <IconButton
                                    style={{
                                        color: "#0188cc",
                                    }}
                                    aria-label="View"
                                    onClick={() => {
                                        this.setState({
                                            editUID:
                                                activeBroadcast.timestamp,
                                            newBroadcast: activeBroadcast,
                                        });
                                        this.handleViewGroupModal();
                                    }}
                                >
                                    <ViewIcon />
                                </IconButton>
                            </p>

                        </div>
                    </div>
                </div>
                <Modal 
                    isOpen={this.state.BroadcastListModal} 
                >
                    <StyledHeader>
                        <center>
                            <Typography
                                variant="h5"
                                style={{
                                    color: "#0288CC",
                                }}
                            >
                                Broadcast List
                            </Typography>
                        </center>
                    </StyledHeader>
                    {/* <ModalHeader>Broadcast List</ModalHeader> */}
                    <ModalBody style={{maxHeight:"650px", overflow:"scroll" }}>
                        <Label style={{ color: "#0288CC" }}>
                            <b>Active Broadcast:</b>
                        </Label>
                        <List>
                            <ListItem
                                style={{
                                    padding: 24,
                                    background: "#80808026",
                                    borderRadius: "5px",
                                    height: "100%",
                                    border: activeBroadcast.warning_level_status === "Green" ? "2px solid green" :
                                        activeBroadcast.warning_level_status === "Red" ? "2px solid red" :
                                            activeBroadcast.warning_level_status === "Yellow" ? "2px solid #d4d44e" :
                                                "2px solid white",
                                }}
                            >
                                <p style={{ marginLeft: "4px", marginBottom: "0px", paddingTop: "2px", fontWeight: "bold", color: this.setFontcolor(activeBroadcast.warning_level_status) }}>
                                    <span>{`${activeBroadcast.message
                                        ? activeBroadcast.message
                                        : "N/A"
                                        }`}
                                    </span>{" "}
                                    <br />
                                    <span style={{ fontSize: "15px", color: this.setBackground(activeBroadcast.warning_level_status) }}>{`${activeBroadcast.warning_level_status
                                        ? activeBroadcast.warning_level_status
                                        : "N/A"
                                        } - `}
                                    </span>{" "}
                                    <span style={{ fontSize: "15px", fontWeight: 300 }}>{`Submitted By: ${activeBroadcast.created_by
                                        ? activeBroadcast.created_by.user_name
                                        : "N/A"
                                        } - `}
                                    </span>{" "}
                                    <span style={{ fontSize: "15px", fontWeight: 300 }}>
                                        {activeBroadcast.timestamp + " "}
                                    </span>
                                    <br />
                                    <IconButton
                                        style={{
                                            color: "#0188cc",
                                        }}
                                        aria-label="View"
                                        onClick={() => {
                                            this.setState({
                                                editUID:
                                                    activeBroadcast.timestamp,
                                                newBroadcast: activeBroadcast,
                                            });
                                            this.handleViewGroupModal();
                                        }}
                                    >
                                        <ViewIcon />
                                    </IconButton>
                                </p>
                            </ListItem>
                        </List>
                        <Label style={{ color: "#0288CC" }}>
                            <b>Past News Broadcasts:</b>
                        </Label>
                        <List>
                            {allBroadcastList &&
                                allBroadcastList.map((broadcast) => {
                                    return (
                                        <ListItem
                                            key={broadcast.timestamp}
                                            style={{
                                                marginTop: "5px",
                                                padding: 24,
                                                background: "#80808026",
                                                height: "100%",
                                                border: broadcast.warning_level_status === "Green" ? "2px solid green" :
                                                        broadcast.warning_level_status === "Red" ? "2px solid red" :
                                                        broadcast.warning_level_status === "Yellow" ? "2px solid #d4d44e" :
                                                            "2px solid white",
                                            }}
                                        >
                                            <p style={{ marginLeft: "4px", marginBottom: "0px", paddingTop: "2px", fontWeight: "bold", color: this.setFontcolor(activeBroadcast.warning_level_status) }}>
                                                <span>{`${broadcast.message
                                                    ? broadcast.message
                                                    : "N/A"
                                                    }`}
                                                </span>{" "}
                                                <br />
                                                <span style={{ fontSize: "15px", color: this.setBackground(broadcast.warning_level_status) }}>{`${broadcast.warning_level_status
                                                    ? broadcast.warning_level_status
                                                    : "N/A"
                                                    } - `}
                                                </span>{" "}
                                                <span style={{ fontSize: "15px", fontWeight: 300 }}>{`Submitted By: ${broadcast.created_by
                                                    ? broadcast.created_by.user_name
                                                    : "N/A"
                                                    } - `}
                                                </span>{" "}
                                                <span style={{ fontSize: "15px", fontWeight: 300 }}>
                                                    {broadcast.timestamp + " "}
                                                </span>
                                                <br />
                                                <IconButton
                                                    style={{
                                                        color: "#0188cc",
                                                    }}
                                                    aria-label="View"
                                                    onClick={() => {
                                                        this.setState({
                                                            editUID:
                                                            broadcast.timestamp,
                                                            newBroadcast: broadcast,
                                                        });
                                                        this.handleViewGroupModal();
                                                    }}
                                                >
                                                    <ViewIcon />
                                                </IconButton>
                                                <IconButton
                                                    style={{
                                                        color: "#0188cc",
                                                    }}
                                                    aria-label="View"
                                                    onClick={() => {
                                                        this.setState({
                                                            editUID:
                                                            broadcast.timestamp,
                                                            newBroadcast: broadcast,
                                                        });
                                                        this.handleEditBroadcastModal();
                                                    }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton
                                                    style={{
                                                        color: "red",
                                                    }}
                                                    aria-label="Delete"
                                                    onClick={() => {
                                                        this.setState(
                                                            {
                                                                removeUID:
                                                                    broadcast.timestamp,
                                                            }
                                                        );
                                                        this.handleRemoveGroupModal();
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </p>
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            variant="contained"
                            onClick={() =>
                                this.setState({
                                    BroadcastListModal: false,
                                })
                            }
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.setBroadcastModal}>
                    <StyledHeader>
                        <center>
                            <Typography
                                variant="h5"
                                style={{
                                    color: "#0288CC",
                                }}
                            >
                                Create New Newsbroadcast
                            </Typography>
                        </center>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <ModalRow>
                                <img style={{ height: "80px", width: "80px", marginLeft: "40%" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/icon.png")} />
                            </ModalRow>
                            <ModalRow>
                                <Col>
                                    <Label
                                        for="name"
                                        style={{ color: "#0288CC" }}
                                    >
                                        <b> News Broadcast Title</b>
                                    </Label>
                                    <div>
                                        <Input
                                            id="name"
                                            multiline={false}
                                            style={{
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                                width: "104%",
                                            }}
                                            label={"Title"}
                                            value={this.state.newBroadcast["message"]}
                                            placeholder="Title"
                                            onChange={(event) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    message: event.target.value,
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow style={{ padding: "0px" }}>
                                <Col>
                                    <Label
                                        style={{ color: "#0288CC" }}
                                        for="rating"
                                    >
                                        <b> Rating </b>
                                    </Label>
                                    <div>
                                        <Select
                                            id="rating"
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={
                                                this.state.newBroadcast[
                                                "warning_level_status"
                                                ]
                                            }
                                            onChange={(event) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    warning_level_status:
                                                        event.target.value,
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        >
                                            <MenuItem
                                                value={"Green"}
                                                key={"green"}
                                            >
                                                Green
                                            </MenuItem>
                                            <MenuItem
                                                value={"Yellow"}
                                                key={"yellow"}
                                            >
                                                Yellow
                                            </MenuItem>
                                            <MenuItem
                                                value={"Red"}
                                                key={"red"}
                                            >
                                                Red
                                            </MenuItem>
                                        </Select>
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>
                                    <Label style={{ color: "#0288CC" }}>
                                        <b> Points: </b>
                                    </Label>
                                    <div style={{ display: "none" }}>

                                        {
                                            typeof this.state.newBroadcast.points === "undefined" || this.state.newBroadcast.points === null ?
                                                this.handleResetBroadcast()
                                                :
                                                ""
                                        }
                                    </div>
                                    <br />
                                    {this.state.newBroadcast.points.length === 0 ?
                                        <AddBoxIcon
                                            color="#0188cc"
                                            onClick={() => {
                                                let timeRef = moment().format('MMMM Do YYYY, h:mm:ss a');
                                                arr = this.state.newBroadcast.points
                                                arr.push({ point: "", timestamp: timeRef })
                                                let broadcast = this.state.newBroadcast;
                                                broadcast.points = arr;
                                                this.setState({ newBroadcast: broadcast })
                                            }}
                                            style={{
                                                margin: "inherit",
                                                color: "#0188cc",
                                                height: "50px",
                                                width: "50px",
                                            }}
                                        ></AddBoxIcon>
                                        :
                                        this.state.newBroadcast.points[this.state.newBroadcast.points.length - 1].point !== ""
                                            ?
                                            <AddBoxIcon
                                                color="#0188cc"
                                                onClick={() => {
                                                    let timeRef = moment().format('MMMM Do YYYY, h:mm:ss a');
                                                    arr = this.state.newBroadcast.points
                                                    arr.push({ point: "", timestamp: timeRef })
                                                    let broadcast = this.state.newBroadcast;
                                                    broadcast.points = arr;
                                                    this.setState({ newBroadcast: broadcast })
                                                }}
                                                style={{
                                                    margin: "inherit",
                                                    color: "#0188cc",
                                                    height: "50px",
                                                    width: "50px",
                                                }}
                                            ></AddBoxIcon>
                                            :
                                            ""
                                    }
                                </Col>
                            </ModalRow>
                            {this.state.newBroadcast.points && this.state.newBroadcast.points.map((e, i) => {
                                return (<React.Fragment>
                                    <ModalRow>
                                        <Col>
                                            <TextField
                                                id="point"
                                                placeholder="Add Point"
                                                style={{ width: "90%" }}
                                                value={e.point}
                                                onChange={(event) => {
                                                    let arr = this.state.newBroadcast.points;
                                                    arr[i].point = event.target.value;
                                                    let broadcast = this.state.newBroadcast;
                                                    broadcast.points = arr;
                                                    this.setState({ newBroadcast: broadcast })
                                                }}
                                            />
                                            <ClearIcon
                                                style={{ color: "red", width: "10%" }}
                                                onClick={() => {
                                                    let pointsArray = []
                                                    this.state.newBroadcast.points.splice(i, 1)
                                                    pointsArray = this.state.newBroadcast.points
                                                    let broadcast = this.state.newBroadcast;
                                                    broadcast.points = pointsArray;
                                                    this.setState({ newBroadcast: broadcast })
                                                }}
                                            ></ClearIcon>
                                        </Col>
                                    </ModalRow>
                                </React.Fragment>)
                            })}
                            {this.renderRequiredGroupDetails()}
                            <ModalRow>
                                <Col>
                                    <Label style={{ color: "#0288CC" }}>
                                        <b>Frequency:</b>
                                    </Label>

                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>

                                    <Label
                                        for="name"
                                        style={{ color: "#0288CC" }}
                                    >
                                        <b> Date Newsbroadcast Start</b>
                                    </Label>
                                    <div>
                                        <DayPickerInput
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={this.state.newBroadcast["start_date"]}
                                            placeholder="Select Start Date"
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            format="DD-MM-YYYY"
                                            onDayChange={(day) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    start_date: moment(day).format("DD-MM-YYYY"),
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>

                                    <Label
                                        for="name"
                                        style={{ color: "#0288CC" }}
                                    >
                                        <b> Date Newsbroadcast End</b>
                                    </Label>
                                    <div>
                                        <DayPickerInput
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={this.state.newBroadcast["end_date"]}
                                            placeholder="Select End Date"
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            format="DD-MM-YYYY"
                                            onDayChange={(day) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    end_date: moment(day).format("DD-MM-YYYY"),
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow style={{ padding: "0px" }}>
                                <Col>
                                    <Label
                                        style={{ color: "#0288CC" }}
                                        for="days"
                                    >
                                        <b> Days Seleced </b>
                                    </Label>
                                    <div>
                                        <Select
                                            id="days"
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={this.state.newBroadcast[
                                                "days"
                                            ] || []}
                                            multiple
                                            onChange={(event) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    days:
                                                        event.target.value,
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        >
                                            <MenuItem
                                                value={"Monday"}
                                                key={"Monday"}
                                            >
                                                Monday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Tuesday"}
                                                key={"Tuesday"}
                                            >
                                                Tuesday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Wednesday"}
                                                key={"Wednesday"}
                                            >
                                                Wednesday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Thursday"}
                                                key={"Thursday"}
                                            >
                                                Thursday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Friday"}
                                                key={"Friday"}
                                            >
                                                Friday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Saturday"}
                                                key={"Saturday"}
                                            >
                                                Saturday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Sunday"}
                                                key={"Sunday"}
                                            >
                                                Sunday
                                            </MenuItem>
                                        </Select>
                                    </div>
                                </Col>
                            </ModalRow>
                        </ModalBody>
                    </StyledContent>
                    {this.state.newBroadcast.points.length !== 0 ?
                        <>
                            {this.state.newBroadcast.points[this.state.newBroadcast.points.length - 1].point === ""
                                ?
                                pointFlag = true
                                :

                                pointFlag = false
                            }
                        </>
                        :
                        pointFlag = false
                    }
                    <ModalFooter>
                        <Button
                            variant="contained"
                            onClick={() =>
                                this.setState({
                                    setBroadcastModal: false,
                                })
                            }
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{background:"#0288CC"}}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                let broadcast = this.state.newBroadcast;
                                broadcast.created_by.user_uid = uid;
                                broadcast.created_by.user_name = name;
                                this.setState({ newBroadcast: broadcast })
                                this.props.addBroadcast(
                                    this.state.newBroadcast
                                );
                                this.setState({ setBroadcastModal: false });
                            }}
                            disabled={
                                this.state.newBroadcast["message"] === ""
                                    ? true
                                    : pointFlag === true
                                        ? true
                                        : false
                            }
                        >
                            Create
                        </Button>
                    </ModalFooter>
                </Modal>
                {/* ------ Edit Modal----- */}
                <Modal isOpen={this.state.editBroadcastModal}>
                    <StyledHeader>
                        <center>
                            <Typography
                                variant="h5"
                                style={{
                                    color: "#0288CC",
                                }}
                            >
                                Edit Newsbroadcast
                            </Typography>
                        </center>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            {
                                typeof this.state.newBroadcast.points === undefined || this.state.newBroadcast.points === null ?
                                    this.handleResetBroadcast()
                                    :
                                    ""
                            }
                            <ModalRow>
                                <img style={{ height: "80px", width: "80px", marginLeft: "40%" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/icon.png")} />
                            </ModalRow>
                            <ModalRow>
                                <Col>
                                    <Label
                                        for="name"
                                        style={{ color: "#0288CC" }}
                                    >
                                        <b> News Broadcast Title</b>
                                    </Label>
                                    <div>
                                        <Input
                                            id="name"
                                            multiline={false}
                                            style={{
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                                width: "104%",
                                            }}
                                            label={"Title"}
                                            value={this.state.newBroadcast["message"]}
                                            placeholder="Title"
                                            onChange={(event) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    message: event.target.value,
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow style={{ padding: "0px" }}>
                                <Col>
                                    <Label
                                        style={{ color: "#0288CC" }}
                                        for="rating"
                                    >
                                        <b> Rating </b>
                                    </Label>
                                    <div>
                                        <Select
                                            id="rating"
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={
                                                this.state.newBroadcast[
                                                "warning_level_status"
                                                ]
                                            }
                                            onChange={(event) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    warning_level_status:
                                                        event.target.value,
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        >
                                            <MenuItem
                                                value={"Green"}
                                                key={"green"}
                                            >
                                                Green
                                            </MenuItem>
                                            <MenuItem
                                                value={"Yellow"}
                                                key={"yellow"}
                                            >
                                                Yellow
                                            </MenuItem>
                                            <MenuItem
                                                value={"Red"}
                                                key={"red"}
                                            >
                                                Red
                                            </MenuItem>
                                        </Select>
                                    </div>
                                </Col>
                            </ModalRow>

                            <ModalRow>
                                <Col>
                                    <Label style={{ color: "#0288CC" }}>
                                        <b> Points: </b>
                                    </Label>
                                    <div style={{ display: "none" }}>
                                        {
                                            typeof this.state.newBroadcast.points === "undefined" || this.state.newBroadcast.points === null ?
                                                this.handleResetBroadcast()
                                                :
                                                ""
                                        }
                                        {
                                            typeof this.state.newBroadcast.created_by === "undefined" || this.state.newBroadcast.created_by === null ?
                                                this.handleResetBroadcastCreatedBy()
                                                :
                                                ""
                                        }
                                    </div>
                                    <br />
                                    <div>
                                        {this.state.newBroadcast.points.length === 0 ?
                                            <AddBoxIcon
                                                color="#0188cc"
                                                onClick={() => {
                                                    let timeRef = moment().format('MMMM Do YYYY, h:mm:ss a');
                                                    typeof this.state.newBroadcast.points === "undefined" || this.state.newBroadcast.points === null
                                                        ? this.handleResetBroadcast()
                                                        : this.handleResetBroadcast(this.state.newBroadcast.points)
                                                    arr = this.state.newBroadcast.points
                                                    arr.push({ point: "", timestamp: timeRef })
                                                    let broadcast = this.state.newBroadcast;
                                                    broadcast.points = arr;
                                                    this.setState({ newBroadcast: broadcast })
                                                }}
                                                style={{
                                                    margin: "inherit",
                                                    color: "#0188cc",
                                                    height: "50px",
                                                    width: "50px",
                                                }}
                                            ></AddBoxIcon>
                                            :
                                            this.state.newBroadcast.points[this.state.newBroadcast.points.length - 1].point !== ""
                                                ?
                                                <AddBoxIcon
                                                    color="#0188cc"
                                                    onClick={() => {
                                                        let timeRef = moment().format('MMMM Do YYYY, h:mm:ss a');
                                                        typeof this.state.newBroadcast.points === "undefined" || this.state.newBroadcast.points === null
                                                            ? this.handleResetBroadcast()
                                                            : this.handleResetBroadcast(this.state.newBroadcast.points)
                                                        arr = this.state.newBroadcast.points
                                                        arr.push({ point: "", timestamp: timeRef })
                                                        let broadcast = this.state.newBroadcast;
                                                        broadcast.points = arr;
                                                        this.setState({ newBroadcast: broadcast })
                                                    }}
                                                    style={{
                                                        margin: "inherit",
                                                        color: "#0188cc",
                                                        height: "50px",
                                                        width: "50px",
                                                    }}
                                                ></AddBoxIcon>
                                                :
                                                ""
                                        }
                                    </div>
                                </Col>
                            </ModalRow>
                            {this.state.newBroadcast.points && this.state.newBroadcast.points.map((e, i) => {
                                return (<React.Fragment>
                                    <ModalRow>
                                        <Col>
                                            <TextField
                                                id="point"
                                                placeholder="Add Point"
                                                style={{ width: "90%" }}
                                                value={e.point}
                                                onChange={(event) => {
                                                    let arr = this.state.newBroadcast.points;
                                                    arr[i].point = event.target.value;
                                                    let broadcast = this.state.newBroadcast;
                                                    broadcast.points = arr;
                                                    this.setState({ newBroadcast: broadcast })
                                                }}
                                            />
                                            <ClearIcon
                                                style={{ color: "red", width: "10%" }}
                                                onClick={() => {
                                                    let pointsArray = []
                                                    this.state.newBroadcast.points.splice(i, 1)
                                                    pointsArray = this.state.newBroadcast.points
                                                    let broadcast = this.state.newBroadcast;
                                                    broadcast.points = pointsArray;
                                                    this.setState({ newBroadcast: broadcast })
                                                }}
                                            ></ClearIcon>
                                        </Col>
                                    </ModalRow>
                                </React.Fragment>)
                            })}
                            <ModalRow>
                                <Col>
                                    <Label style={{ color: "#0288CC" }}>
                                        <b>Attached Photos:</b>
                                    </Label>

                                </Col>
                            </ModalRow>
                            <div style={{ display: "none" }}>
                                {/* {typeof this.state.newBroadcast.attached_photos === "undefined" || this.state.newBroadcast.attached_photos === null
                                    ? this.handleResetPhotos()
                                    : this.handleResetPhotos(this.state.newBroadcast.attached_photos) 
                                } */}
                            </div>
                            <div>
                                {this.state.newBroadcast.attached_photos &&
                                    this.state.newBroadcast.attached_photos.map((photo, i) => {
                                        return (
                                            <img
                                                src={
                                                    photo !== ""
                                                        ? photo
                                                        : noImg
                                                }
                                                onClick={() => {
                                                    this.setState({
                                                        selectedImg: photo,
                                                        imageModal: true,
                                                    });
                                                }}
                                                alt=""
                                                style={{
                                                    width: 100,
                                                    height: 100,
                                                    padding: "10px",
                                                    borderRadius: "22px",
                                                    marginLeft: "11px",
                                                    border: "2px solid #0188cc",
                                                    cursor:"pointer"
                                                }}
                                            />
                                        );
                                    })}
                            </div>
                            <ModalRow>
                                <Col>
                                    <Label style={{ color: "#0288CC" }}>
                                        <b>Frequency:</b>
                                    </Label>

                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>

                                    <Label
                                        for="name"
                                        style={{ color: "#0288CC" }}
                                    >
                                        <b> Date Newsbroadcast Start</b>
                                    </Label>
                                    <div>
                                        <DayPickerInput
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={this.state.newBroadcast["start_date"]}
                                            placeholder="Select Start Date"
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            format="DD-MM-YYYY"
                                            onDayChange={(day) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    start_date: moment(day).format("DD-MM-YYYY"),
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>

                                    <Label
                                        for="name"
                                        style={{ color: "#0288CC" }}
                                    >
                                        <b> Date Newsbroadcast End</b>
                                    </Label>
                                    <div>
                                        <DayPickerInput
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={this.state.newBroadcast["end_date"]}
                                            placeholder="Select End Date"
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            format="DD-MM-YYYY"
                                            onDayChange={(day) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    end_date: moment(day).format("DD-MM-YYYY"),
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow style={{ padding: "0px" }}>
                                <Col>
                                    <Label
                                        style={{ color: "#0288CC" }}
                                        for="days"
                                    >
                                        <b> Days Seleced </b>
                                    </Label>
                                    <div>
                                        <Select
                                            id="days"
                                            style={{
                                                width: "104%",
                                                border:
                                                    "2px solid #0188cc",
                                                borderRadius: "9px",
                                            }}
                                            value={this.state.newBroadcast[
                                                "days"
                                            ] || []}
                                            multiple
                                            onChange={(event) => {
                                                let newBroadcast = {
                                                    ...this.state.newBroadcast,
                                                    days:
                                                        event.target.value,
                                                };
                                                this.setState({ newBroadcast });
                                            }}
                                        >
                                            <MenuItem
                                                value={"Monday"}
                                                key={"Monday"}
                                            >
                                                Monday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Tuesday"}
                                                key={"Tuesday"}
                                            >
                                                Tuesday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Wednesday"}
                                                key={"Wednesday"}
                                            >
                                                Wednesday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Thursday"}
                                                key={"Thursday"}
                                            >
                                                Thursday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Friday"}
                                                key={"Friday"}
                                            >
                                                Friday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Saturday"}
                                                key={"Saturday"}
                                            >
                                                Saturday
                                            </MenuItem>
                                            <MenuItem
                                                value={"Sunday"}
                                                key={"Sunday"}
                                            >
                                                Sunday
                                            </MenuItem>
                                        </Select>
                                    </div>
                                </Col>
                            </ModalRow>
                            <ModalRow>
                                <Col>
                                    {this.state.confirmButton ?
                                        <>
                                            <br />
                                            <div style={{ border: "2px solid #0288CC", borderRadius: 5, height: "102px" }}>
                                                <p style={{ color: "red", fontWeight: "bold" }}>
                                                    Would you like to re-submit this Newbroadcast as "Active"
                                                <br />
                                                    <br />
                                                    <Button
                                                        style={{ marginLeft: "20%", background: "#0288CC", marginRight: "5px", marginTop: "-35px" }}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            let broadcast = this.state.newBroadcast;
                                                            broadcast.created_by.user_uid = uid;
                                                            broadcast.created_by.user_name = name;
                                                            this.setState({ newBroadcast: broadcast })
                                                            this.props.addBroadcast(
                                                                this.state.newBroadcast
                                                            );
                                                            this.setState({ confirmButton: false })
                                                            this.handleEditBroadcastCloseModal()
                                                        }}
                                                    >
                                                        Yes
                                            </Button>
                                                    <Button
                                                        style={{ marginRight: "5px", marginLeft: "6%", marginTop: "-37px" }}
                                                        variant="contained"
                                                        onClick={() => {
                                                            this.props.updateExistingBroadcast(
                                                                this.state.newBroadcast
                                                            );
                                                            this.setState({ confirmButton: false })
                                                            this.handleEditBroadcastCloseModal()
                                                        }}
                                                    >
                                                        No
                                            </Button>
                                                </p>

                                            </div>
                                        </>
                                        :
                                        ""
                                    }
                                </Col>
                            </ModalRow>
                        </ModalBody>
                    </StyledContent>
                    {this.state.newBroadcast.points.length !== 0 ?
                        <>
                            {this.state.newBroadcast.points[this.state.newBroadcast.points.length - 1].point === ""
                                ?
                                pointFlag = true
                                :

                                pointFlag = false
                            }
                        </>
                        :
                        pointFlag = false
                    }
                    {this.state.confirmButton ?
                        ""
                        :
                        <ModalFooter>
                            <Button
                                variant="contained"
                                onClick={() =>
                                    this.handleEditBroadcastCloseModal()
                                }
                            >
                                Cancel
                        </Button>
                            <Button
                                style={{background:"#0288CC"}}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.setState({ confirmButton: true })
                                }}
                                disabled={
                                    this.state.newBroadcast["message"] === ""
                                        ? true
                                        : pointFlag === true
                                            ? true
                                            : false
                                }
                            >
                                Update
                        </Button>
                        </ModalFooter>
                    }
                </Modal>
                {/* --- View Modal----- */}
                <div>
                    <Modal
                        isOpen={this.state.viewBroadcastModal}
                    >
                        <StyledHeader>
                        <center>
                            <Typography
                                variant="h5"
                                style={{
                                    color: "#0288CC",
                                }}
                            >
                                Broadcast Details
                            </Typography>
                        </center>
                    </StyledHeader>
                        <StyledContent>
                            <ModalBody>
                                <ModalRow>
                                    <Col>
                                        <div>
                                            <Label for="name">
                                                News Broadcast Title&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                            <span
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {" "}
                                                {
                                                    this.state.newBroadcast
                                                        .message
                                                }{" "}
                                            </span>
                                            <br />
                                        </div>
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        <div>
                                            <Label for="name">
                                                Rating&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                            <span
                                                style={{
                                                    fontWeight: "bold",
                                                    color: this.setBackground(
                                                        this.state.newBroadcast.warning_level_status
                                                    ),
                                                }}
                                            >
                                                {
                                                    this.state.newBroadcast
                                                        .warning_level_status
                                                }
                                            </span>
                                            <br />
                                        </div>
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        {this.state.newBroadcast.points ?
                                            <>
                                                <div>
                                                    <List style={{ background: "#eee" }}>
                                                        <div style={{ clear: "both", border: "2px solid #0188cc", borderRadius: "6px", marginLeft: "5px", marginTop: "10px" }}>
                                                            <h1 style={{
                                                                backgroundColor: "#0188cc",
                                                                textAlign: "center",
                                                                padding: "4px",
                                                                fontWeight: "bold",
                                                                color: "white",
                                                                fontSize: "22px"
                                                            }}>
                                                                Points
                                                </h1>
                                                        </div>
                                                        {this.state.newBroadcast.points && this.state.newBroadcast.points
                                                            .map((e, index) => {
                                                                return (
                                                                    <StyledListItem
                                                                        borderColor={"#0188cc"}
                                                                        style={{
                                                                            root: {
                                                                                borderLeft: "#0188cc",
                                                                            },
                                                                        }}
                                                                    >
                                                                        <Grid container spacing={4}>
                                                                            <Grid item sm={12} md={12} lg={12} xl={12}>
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    style={{ paddingLeft: 24 }}
                                                                                >
                                                                                    {e.point}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </StyledListItem>
                                                                );
                                                            })}
                                                    </List>
                                                </div>
                                                <br />
                                            </>
                                            :
                                            ""
                                        }
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        {this.state.newBroadcast.attached_photos ?
                                            <h5 style={{ color: "#0188cc" }}>Broadcast Photos:</h5>
                                            :
                                            ""
                                        }
                                        <div>
                                            {this.state.newBroadcast.attached_photos &&
                                                this.state.newBroadcast.attached_photos.map((e, i) => {
                                                    return (
                                                        <img
                                                            src={
                                                                e ? e
                                                                    : noImg
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    selectedImg: e,
                                                                    imageModal: true,
                                                                });
                                                            }}
                                                            alt="evidence"
                                                            style={{
                                                                width: 100,
                                                                height: 100,
                                                                padding: "10px",
                                                                borderRadius: "22px",
                                                                marginLeft: "11px",
                                                                border: "2px solid #0188cc",
                                                                cursor:"pointer"
                                                            }}
                                                        />
                                                    );
                                                })}
                                        </div>
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        <h5 style={{ color: "#0188cc" }}>Frequency</h5>
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        <div>
                                            <Label for="start">
                                                News Broadcast Start Date&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                            <span
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {
                                                    this.state.newBroadcast.start_date ?
                                                        this.state.newBroadcast.start_date
                                                        : "N/A"
                                                }
                                            </span>
                                            <br />
                                        </div>
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        <Label for="end">
                                            News Broadcast End Date&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                        <span
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {
                                                this.state.newBroadcast.end_date ?
                                                    this.state.newBroadcast.end_date
                                                    : "N/A"
                                            }
                                        </span>
                                        <br />
                                    </Col>
                                </ModalRow>
                                <ModalRow>
                                    <Col>
                                        <Label for="priority">
                                            Days Selected&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                        <span
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {
                                                this.state.newBroadcast.days && this.state.newBroadcast.days.map((e) => {
                                                    return `${e} , `;
                                                })
                                            }
                                        </span>
                                        <br />
                                    </Col>
                                </ModalRow>
                            </ModalBody>
                        </StyledContent>
                        <ModalFooter>
                            <div>
                                <Button
                                    style={{background:"#0288CC"}}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleCloseViewGroupModal}
                                >
                                    Cancel
                                    </Button>
                            </div>
                        </ModalFooter>
                    </Modal>
                </div>
                <div>
                    <Modal
                        isOpen={this.state.removeBroadcastModal}
                    >
                        <StyledHeader>
                        <center>
                            <Typography
                                variant="h5"
                                style={{
                                    color: "#0288CC",
                                }}
                            >
                                Delete Broadcast
                            </Typography>
                        </center>
                    </StyledHeader>
                        <StyledContent>
                            <ModalBody>
                                <Typography variant="body2">
                                    Are you sure you want to delete this
                                        Broadcast? <br />
                                </Typography>
                            </ModalBody>
                        </StyledContent>
                        <ModalFooter>
                            <div>
                                <Button
                                    onClick={
                                        this.handleCloseRemoveGroupModal
                                    }
                                >
                                    Cancel
                                    </Button>
                                <Button
                                    style={{background:"red"}}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.props.removeBroadcast(
                                            this.state.removeUID
                                        );
                                        this.handleCloseRemoveGroupModal();
                                    }}
                                >
                                    Delete
                                    </Button>
                            </div>
                        </ModalFooter>
                    </Modal>
                </div>
                <div>
                <Modal isOpen={this.state.imageModal}>
                    <StyledHeader>
                            <center>
                                <Typography
                                    variant="h5"
                                    style={{
                                        color: "#0288CC",
                                    }}
                                >
                                    View Image
                                </Typography>
                            </center>
                        </StyledHeader>
                        <StyledContent>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                            selectedImg === null ||
                                            selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                </div>
                <MaxFileSizeSnackbar
                    fileMaxSizeSnackbar={
                        this.state.fileMaxSizeSnackbar
                    }
                    setState={() =>
                        this.setState({
                            fileMaxSizeSnackbar: false,
                        })
                    }
                />
            </Grid>
        );
    }
}
export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectActiveBroadcast, getUserProfile, selectAllBroadcastList } = selectors;
            return {
                activeBroadcast: selectActiveBroadcast(store),
                userProfile: getUserProfile(store),
                allBroadcastList: selectAllBroadcastList(store)
            };
        },
        { getBroadcast, addBroadcast, uploadFile, uploadFileManager, removeBroadcast, updateExistingBroadcast }
    )(NewsBroadcastV2)
);
